import store from "../store";

import axios from "axios";
import {
  getAuth,
  signOut,
  signInAnonymously,
  onAuthStateChanged,
} from "firebase/auth";
import {
  getFirestore,
  // collection,
  // getDocs,
  // where,
  // query,
} from "firebase/firestore";
export const GlobalFunction = {
  data() {
    return {
      auth: getAuth(),
      db: getFirestore(),
      q: null,
    };
  },
  methods: {
    async signIn() {
      if (this.$refs.form.validate()) {
        // console.log("Sign In");
        console.log(this.user);
        var data = this.user;
        var config = {
          method: "post",
          url: "https://rsuapi.rsu.ac.th/emp_authen_n_get_data",
          headers: {
            Authorization: "Bearer " + store.myidpass,
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then(
            function (response) {
              console.log(response);
              if (response.data.status == true) {
                this.userData = response.data.data;
                store.role = "user";
                this.role = store.role;
                this.anonymouslySignIn();
                this.signinButtonLoading = true;
                store.user = this.userData;
                localStorage.user = JSON.stringify(store.user);
                localStorage.role = JSON.stringify(store.role);
                const d = new Date();
                localStorage.time = d.getTime();
                // this.$router.push({ path: "/transaction" });
              } else {
                this.snackbar = true;
              }
            }.bind(this)
          )

          .catch(
            function (error) {
              console.log(error);
            }.bind(this)
          );
      }
    },

    SignOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // Sign-out successful.

          this.user = {};
          localStorage.removeItem("user");
          localStorage.removeItem("role");
          localStorage.removeItem("time");

          store.user = null;
          store.role = null;
          store.time = null;
          this.signInState = false;
          this.$router.push({ path: "/" });
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
          this.$router.push({ path: "/" });
        });
    },

    async checkSignIn() {
      // console.log(localStorage.time);
      if (
        localStorage.user != undefined &&
        localStorage.role != undefined &&
        localStorage.time != undefined
      ) {
        store.user = JSON.parse(localStorage.user);
        store.role = JSON.parse(localStorage.role);
        store.time = JSON.parse(localStorage.time);
        // Add timestamp in localstorage
        this.user = store.user;
        this.role = store.role;

        this.time = store.time;
        // console.log(store.time);
        var d = new Date();
        var diff = (d.getTime() - store.time) / 1000;
        diff /= 60;
        // console.log(Math.abs(Math.round(diff)));
        if (Math.abs(Math.round(diff)) < 180) {
          this.showUser();
          if (store.role == "user") {
            this.signInState = true;
            if (!window.location.href.includes("transaction")) {
              this.$router.push({ path: "/transaction" });
            }
          } else {
            this.$router.push({ path: "/" });
          }
        } else {
          this.SignOut();
        }
      } else {
        this.SignOut();
      }
    },
    async anonymouslySignIn() {
      const auth = getAuth();
      signInAnonymously(auth)
        .then(() => {})
        .catch((error) => {
          console.log(error);

          // ...
        });
    },

    authStateChanged() {
      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          this.checkSignIn();
          // ...
        } else {
          // console.log("insufficient permissions");
        }
      });
    },

    showUser() {
      this.userData = store.user;
    },
    // async checkHospital(user) {
    //     // console.log(user.email);

    //     const q = query(
    //       collection(this.db, "hospitaluser"),
    //       where("email", "==", user.email)
    //     );
    //     const querySnapshot = await getDocs(q);

    //     // console.log(querySnapshot);

    //     if (querySnapshot.empty) {
    //       this.SignOut();
    //       // console.log("Not Admin.");
    //       this.snackbar = true;
    //     } else {
    //       // console.log("Admin");

    //       store.user = user;
    //       // console.log(store.user);
    //       localStorage.user = JSON.stringify(store.user);
    //       localStorage.token = JSON.stringify(store.token);

    //       this.$router.push({ path: "/checkprivilege" });
    //     }
    //   },
  },
};
